<div class="mb-6">

  @if (true) {

    <div [formGroup]="filtri">

      <!-- filtri iscritti -->
      <div class="flex flex-column align-items-center sm:flex-row mb-5 pt-5">

        <!-- filtri -->
        <div class="flex align-items-center justify-content-center mb-5 sm:mb-0">

          <!-- ricerca iscritti -->
          <div class="sm:mr-3">
            <span class="p-input-icon-left p-input-icon-right p-float-label">
              <i class="pi pi-search"></i>
              <input type="text" id="cercaIscritto" class="shadow-4" pInputText formControlName="inserimento" />
              <label for="cercaIscritto">
                {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.cerca') }}
              </label>
              <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
            </span>
          </div>

        </div>

        <div class="flex bottoniStyle">
          @if(xlsSpinner){
            <div class="pr-4 pt-2">
              <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
            </div>
          }
          @else{
            <p-button
              type="button"
              icon="pi pi-table"
              iconPos="right"
              class="mr-3"
              (click)="printIscrittiXLS()"
              [pTooltip]="translate.instant('tooltip.xls')"
              tooltipPosition="bottom"
              [disabled]="!role_service.isAlboOrConsultazione()" />
          }
          <p-menu #menu [model]="vociStampa" [popup]="true" appendTo="body"></p-menu>
          <button
            pButton
            type="button"
            class="mr-3"
            (click)="menu.toggle($event)"
            icon="pi pi-print"
            [disabled]="!role_service.isAlboOrConsultazione()"
            [pTooltip]="translate.instant('tooltip.stampe')"
            tooltipPosition="bottom"></button>
          <p-button
            type="button"
            routerLink="/gestione_albo/nuovo_iscritto"
            icon="pi pi-plus"
            iconPos="right"
            [pTooltip]="translate.instant('tooltip.nuovoIscritto')"
            tooltipPosition="bottom"
            [disabled]="!role_service.isIscrizioniRole()" />
        </div>

      </div>

      <!-- avanzati -->
      <div class="flex align-items-center justify-content-center sm:justify-content-start mb-5 flex-wrap gap-3">
        <div class="mb-3 sm:mb-0">
          <p-dropdown
            formControlName="stato"
            [showClear]="true"
            [options]="statiDropdown"
            optionLabel="nome"
            [placeholder]="translate.instant('gestioneAlbo.gestioneIscritti.filtri.stato')" />
        </div>

        <div class="mb-3 sm:mb-0">
          <p-dropdown
            formControlName="sezione"
            [showClear]="true"
            [options]="sezioniDropdown"
            optionLabel="nome"
            [placeholder]="translate.instant('gestioneAlbo.gestioneIscritti.filtri.sezione')" />
        </div>

        <div>
          <p-button
            icon="pi pi-filter"
            iconPos="right"
            class="filtriAvanzatiBtn mb-3 sm:mb-0"
            [badge]="numeroFiltriAvanzati.toString()"
            (click)="showFilters()"
            [label]="translate.instant('gestioneAlbo.gestioneIscritti.filtri.avanzati')" />
        </div>

        <p-button
          class="clearFiltri"
          size="small"
          [outlined]="true"
          icon="pi pi-filter-slash"
          (click)="clearFilters()"
          [pTooltip]="translate.instant('tooltip.pulisciFiltri')"
          tooltipPosition="right" />
      </div>

      @if(showAdvancedFilters){
        <!-- FILTRI AVANZATI -->
        <div class="flex flex-column w-full gap-1 border-round shadow-4 mb-5 p-3">
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.provinciaResidenza') }}
            </p>
            <p-dropdown
              formControlName="residenzaProvincia"
              [showClear]="true"
              [options]="provinceDropdown"
              optionLabel="nome"
              placeholder="--"
              class="w-6" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.comuneResidenza') }}
            </p>
            <p-autoComplete
              appendTo="body"
              formControlName="residenzaComune"
              [suggestions]="filteredComuni"
              (completeMethod)="filterAutoComplete($event, 'comuni')"
              field="nome"
              [minLength]="3"
              [showClear]="true"
              placeholder="--"
              class="w-6">
              <ng-template let-comune pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ comune.nome }}</div>
                </div>
              </ng-template>
            </p-autoComplete>
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.provinciaDomicilio') }}
            </p>
            <p-dropdown
              formControlName="domicilioProvincia"
              [showClear]="true"
              [options]="provinceDropdown"
              optionLabel="nome"
              placeholder="--"
              class="w-6" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.comuneDomicilio') }}
            </p>
            <p-autoComplete
              appendTo="body"
              formControlName="domicilioComune"
              [suggestions]="filteredComuni"
              (completeMethod)="filterAutoComplete($event, 'comuni')"
              field="nome"
              [minLength]="3"
              [showClear]="true"
              placeholder="--"
              class="w-6">
              <ng-template let-comune pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ comune.nome }}</div>
                </div>
              </ng-template>
            </p-autoComplete>
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.annoNascita') }}
            </p>
            <div class="flex align-items-center justify-content-between w-6 gap-3">
              <div class="w-6">
                <p-inputNumber
                  inputId="annoNascita"
                  [useGrouping]="false"
                  formControlName="annoNascita"
                  [minlength]="4"
                  [maxlength]="4"
                  [showClear]="true"
                  [placeholder]="translate.instant('dal')" />
              </div>
              <div class="w-6">
                <p-inputNumber
                  inputId="annoNascitaAl"
                  [useGrouping]="false"
                  formControlName="annoNascitaAl"
                  [minlength]="4"
                  [maxlength]="4"
                  [showClear]="true"
                  [placeholder]="translate.instant('al')" />
              </div>
            </div>
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.dataIscrizione') }}
            </p>
            <div class="flex align-items-center justify-content-between w-6 gap-3">
              <div class="w-6">
                <p-calendar
                  formControlName="dataIscrizione"
                  dateFormat="dd/mm/yy"
                  inputId="dataIscrizione"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  [showClear]="true"
                  [placeholder]="translate.instant('dal')" />
              </div>
              <div class="w-6">
                <p-calendar
                  formControlName="dataIscrizioneAl"
                  dateFormat="dd/mm/yy"
                  inputId="dataIscrizioneAl"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  [showClear]="true"
                  [placeholder]="translate.instant('al')" />
              </div>
            </div>
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.titolo') }}
            </p>
            <p-dropdown
              formControlName="titoli"
              [showClear]="true"
              [options]="titoliDropdown"
              optionLabel="nome"
              placeholder="--"
              class="w-6" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.noPec') }}
            </p>
            <p-checkbox
              formControlName="noPec"
              [binary]="true" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.permessoSoggiorno') }}
            </p>
            <p-checkbox
              formControlName="permessoSoggiorno"
              [binary]="true" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.ctu') }}
            </p>
            <p-dropdown
              formControlName="ctu"
              [showClear]="true"
              [options]="ctuDropdown"
              optionLabel="nome"
              placeholder="--"
              class="w-6" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">
              {{ translate.instant('gestioneAlbo.gestioneIscritti.filtri.perito') }}
            </p>
            <p-dropdown
              formControlName="perito"
              [showClear]="true"
              [options]="ctuDropdown"
              optionLabel="nome"
              placeholder="--"
              class="w-6" />
          </div>
        </div>
      }

        <!-- PAGINATOR della tabella -->
      <div class="flex justify-content-start mb-5">
        <p-paginator
          [rows]="pageSize"
          [first]="currentPage"
          [rowsPerPageOptions]="[25, 100, 250, 500]"
          (onPageChange)="pageChange($event)"
          [totalRecords]="totaleDati"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} di {totalRecords}"
          [showPageLinks]="false" />
      </div>

    </div>

  }


  <!-- tabella -->
  <div>
    <p-table
      #dt
      [value]="listaIscritti"
      [rowHover]="true"
      (onLazyLoad)="ordinamento($event)"
      [customSort]="true"
      [lazy]="true"
      [sortField]="orderColumnName"
      [sortOrder]="orderCustom(order)"
    >
      <!-- headers -->
      <ng-template pTemplate="header">
          <tr>
            @for(headerName of headersTabella; track $index){
              <th
                [pSortableColumn]="headerName === 'Stato' ? '' : rowsTabella[$index]"
              >
                {{ headerName }}
                @if(headerName !== 'Stato'){
                  <p-sortIcon [field]="rowsTabella[$index]"></p-sortIcon>
                }
              </th>
            }
          </tr>
      </ng-template>

      <!-- rows -->
      <ng-template pTemplate="body" let-iscritto>

          <tr style="cursor: pointer;" [routerLink]="generaRoutingLink(iscritto)">

            @for (rowName of rowsTabella; track $index) {

              @if (rowName === 'statoIscritto') {
                <td class="font-bold" [style.color]="coloreStato(iscritto.statoIscritto)">
                  {{ iscritto.statoIscritto.nome }}
                </td>
              }@else{
                <td>{{ iscritto[rowName] }}</td>
              }

            }
          </tr>
      </ng-template>
    </p-table>

  </div>

  <p-toast position="bottom-center"></p-toast>

</div>
